module.exports = __webpack_public_path__ + "f3175f7492888e0dc9376af2993645e5.svg";